export default function SvgArrowUp({ stroke = '#ECECEB' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_9360_432"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect
          width="20"
          height="20"
          transform="matrix(0 -1 -1 0 20 20)"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9360_432)">
        <path
          d="M10 17.5L10 2.5"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1667 6.6665L10.0001 2.49984L5.83341 6.6665"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
